import $ from 'jquery';

const toggleVisibilityEmployeeButton = $('.js-employee-card__button'),
    employeeCards = $('.js-employee-card'),
    hiddenClass = 'hidden';

const handleEmployeeCardVisibility = () => {
    const toggleButtonText = employeeCards.eq(1).hasClass(hiddenClass) ? 'Скрыть специалистов' : 'Все специалисты';

    employeeCards.slice(1).each((index, card) => {
        $(card).toggleClass(hiddenClass);
    });

    toggleVisibilityEmployeeButton.html(toggleButtonText);
};

handleEmployeeCardVisibility();

toggleVisibilityEmployeeButton.on('click', handleEmployeeCardVisibility);
